export default __webpack_public_path__ + "static/media/contacto_w_bg.4236c4e6.png";